export enum apiUrlPaymentPlan {
    PAYMENT_PLAN = '/v1/payment_plan/',
}
